import React, { useState, useEffect } from "react";
import axios from "axios";
import AuthUser from "./AuthUser";
import toast, { Toaster } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import Autosuggest from "react-autosuggest";
import { useParams } from "react-router-dom";
import moment from "moment";

// Add print styles
const printStyles = `
  @media screen, print {
    .status-box {
      border: 2px solid #0d6efd !important;
      border-radius: 8px !important;
      padding: 8px 15px !important;
      background-color: #f8f9fa !important;
      display: inline-block !important;
      margin-left: auto !important;
    }
  }
  @media print {
    @page {
      size: A4;
      margin: 10mm;
    }
    html, body {
      margin: 0;
      padding: 0;
    }
    .print-button {
      display: none !important;
    }
    nav, .navbar {
      display: none !important;
    }
    .receipt-main {
      break-inside: avoid;
      page-break-inside: avoid;
      margin-bottom: 20px;
    }
    .print-section {
      page-break-before: always;
    }
    .table {
      margin-bottom: 0.5rem;
    }
    .mb-2 {
      margin-bottom: 0.25rem !important;
    }
    .mt-2 {
      margin-top: 0.25rem !important;
    }
    .p-1 {
      padding: 0.25rem !important;
    }
    .tc p {
      margin-bottom: 0.25rem;
    }
    .orginal-container {
      margin-bottom: 10px;
    }
    .status-box p {
      white-space: nowrap !important;
      word-break: keep-all !important;
    }
  }
`;

export default function Print() {
  const navigate = useNavigate();
  const { id } = useParams();
  const { http, user } = AuthUser();
  const [usersjob, setUsersJob] = useState([]);
  const [loading, setLoading] = useState(true);

  // Add print styles to document
  useEffect(() => {
    // Create style element
    const styleElement = document.createElement('style');
    styleElement.innerHTML = printStyles;
    document.head.appendChild(styleElement);

    // Cleanup on unmount
    return () => {
      document.head.removeChild(styleElement);
    };
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await http.get(`/tasks_job_ind_print?&id=${id}`);
        // Simulate a 20-second delay using setTimeout
        setTimeout(() => {
          setUsersJob(response.data.data);
          setLoading(false); // Set loading to false after setting the state
        }, 200); // 20 seconds in milliseconds
      } catch (error) {
        console.error("Error fetching data:", error);
        setLoading(false); // Set loading to false in case of an error
      }
    };

    fetchData();
  }, [id]);

  if (loading) {
    return <p>Loading...</p>;
  }
  if (!Array.isArray(usersjob) || usersjob.length === 0 || !usersjob[0]) {
    return (
      <div className="p-3">
        <p className="text-danger mb-2">Job card not found.</p>
        <button className="btn btn-secondary btn-sm" onClick={() => window.history.back()}>
          Back
        </button>
      </div>
    );
  }
  const handlePrint = () => {
    window.print();
  };
  return (
    <div style={{ margin: 0, padding: 0 }}>
      <div className="col-md-12 text-end mt-2 mb-1">
        <button className="print-button btn btn-primary" onClick={handlePrint}>
          Print Preview
        </button>
      </div>
      <div className="col-md-12 col-sm-12">
        <div className="row container-fluid">
          <div className="receipt-main col-md-12 col-sm-12">
            <div className="row">
              <div className="orginal-container">
                <p className="orginal-text text-primary">
                  <b className="text-uppercase">Customer Copy</b>
                </p>
              </div>
            </div>
            <div className="receipt-header">
              <div className="row">
                <div className="receipt-left col-md-2 col-sm-2">
                  <img
                    src="/logo.png"
                    alt="Default Logo"
                    width="89"
                    height="45"
                  />
                </div>

                <div className="col-md-8 col-sm-8 text-center">
                  {usersjob[0].assiger_branch == 1 && (
                    <div className="receipt-right">
                      <h5>KATZE TECHNOLIGIES - CORPORATE OFFICE</h5>
                      <p>2ND FLOOR, GNR COMPLEX, NEAR SBI BANK,</p>
                      <p>ANEKAL ROAD, CHANDAPURA - 560099</p>
                      <p className="text-ph">
                        <b>MB: 89515 50360</b>
                      </p>
                      <p>Sales@katzeindia.com, www.katzeindia.com</p>
                      <br />
                    </div>
                  )}

                  {usersjob[0].assiger_branch == 2 && (
                    <div className="receipt-right">
                      <h5>KATEZE TECHNOLOGIES - LAPTOPS STORE</h5>
                      <p>4, PARVATHI PLAZA, OPP ANR KALAYNAMANTAP.</p>
                      <p>CHANDAPURA - 560099</p>
                      <p className="text-ph">
                        <b>MB 960 682 4959</b>
                      </p>
                      <p>Sales@katzeindia.com, www.katzeindia.com</p>
                      <br />
                    </div>
                  )}
                </div>
                <div className="col-sm-2"></div>

                <div className="col-md-6 col-sm-6 ">
                  <div className="receipt-right">
                    <p className="pb-1">
                      <b>Customer: </b><b className="h6">{usersjob[0].customer?.company}</b>
                    </p>
                    <h4 className="text-uppercase">
                      <b>{usersjob[0].customer?.name}</b>
                    </h4>
                    <span>
                      <p>
                        <b>
                          <h4 className="text-uppercase">
                            <b>{usersjob[0].customer?.phone}</b>
                          </h4>
                        </b>
                      </p>
                    </span>
                    <p>
                      Email: <b>{usersjob[0].customer?.email}</b>
                    </p>
                    <p>
                      Location: <b>{usersjob[0].customer?.address}</b>
                    </p>
                  </div>
                </div>

                <div className="col-md-6 col-sm-6 text-right-print">
                  <div className="receipt-right">
                    <h5>
                      Job Card No:{" "}
                      <b> {usersjob[0].assiger_branch == 1 ? "K1" : "K2"}</b>
                      {"-"}
                      <b> JC{usersjob[0].id}</b>
                    </h5>
                    <p>
                      Date:
                      <b>
                        {moment(usersjob[0].created_at).format(
                          "DD MMM, YYYY hh:mm A"
                        )}
                      </b>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-4 col-sm-4">
                <table className="table">
                  <tbody>
                    <tr>
                      <td>
                        Received By:{" "}
                        <b className="text-uppercase">
                          {" "}
                          {usersjob[0].assigner?.name}{" "}
                          {usersjob[0].assigner?.last_name}
                        </b>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Brand / Others:{" "}
                        <b className="text-uppercase">{usersjob[0].brand}</b>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div className="col-md-4 col-sm-4">
                <table className="table">
                  <tbody>
                    <tr>
                      <td>
                        Product Name:{" "}
                        <b className="text-uppercase">
                          {usersjob[0].product_name}
                        </b>
                      </td>
                    </tr>

                    <tr>
                      <td>
                        Model:{" "}
                        <b className="text-uppercase">{usersjob[0].model}</b>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div className="col-md-4 col-sm-4">
                <table className="table">
                  <tbody>
                    <tr>
                      <td>
                        Password: <b>{usersjob[0].type}</b>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Priority:{" "}
                        <b className="text-uppercase">{usersjob[0].priority}</b>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div className="col-md-6 col-sm-6">
                <table className="table">
                  <tbody>
                    <tr>
                      <td>
                        Power adapter:{" "}
                        <b>{usersjob[0].power_adapter == 1 ? "YES" : "NO"}</b>
                      </td>
                      <td>
                      Antivirus Required ?{" "}
                        <b>{usersjob[0].carry_case == 1 ? "YES" : "NO"}</b>
                      </td>
                      <td>
                        Laptop Bag:{" "}
                        <b>{usersjob[0].laptop_bag == 1 ? "YES" : "NO"}</b>
                      </td>
                    </tr>
                    <tr>
                      <td colSpan="2">
                        JC Seat Submitted:{" "}
                        <b>
                          {usersjob[0].jc_seat_submitted === "yes"
                            ? "YES"
                            : usersjob[0].jc_seat_submitted === "no"
                            ? "NO"
                            : "N/A"}
                        </b>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div className="col-md-6 col-sm-6 border border-secondery rounded">
                <p className="mb-0">
                  .....................................................................
                </p>
                <p className="mb-0">
                  .....................................................................
                </p>
                <p className="mb-0">
                  .....................................................................
                </p>
              </div>

              <div className="col-md-7 col-sm-7">
                <b>Description / Issues: </b>
                <div className="border border-primary p-1 mb-2 rounded">
                  <p>
                    {usersjob[0].description ? usersjob[0].description : "N/A"}
                  </p>
                </div>
              </div>

              <div className="col-md-5 col-sm-5 mt-1">
                <b>Engg Remarks / Attended By: </b>
                <div className="border border-primary p-1 mb-2 rounded">
                  {" "}
                  <p>
                    {usersjob[0].eng_remark ? usersjob[0].eng_remark : "N/A"}
                  </p>
                </div>
              </div>

              <div className="col-md-4 col-sm-4">
                <b>Damage Remarks: </b>
                <div className="border border-secondery p-1 mb-2 rounded">
                  <p>
                    {usersjob[0].damage_remark
                      ? usersjob[0].damage_remark
                      : "N/A"}
                  </p>
                </div>
              </div>

              <div className="col-md-4 col-sm-4">
                <b>Service Amount: </b>
                <div className="border border-secondery p-1 mb-1 rounded">
                  <p>
                    {usersjob[0].service_amount
                      ? usersjob[0].service_amount
                      : "N/A"}
                  </p>
                </div>
              </div>

              <div className="col-md-4 col-sm-4">
                <b>Tentative Delivery date: </b>
                <div className="border border-secondery p-1 mb-1 rounded">
                  {" "}
                  <p>
                    {usersjob[0].del_date
                      ? moment(usersjob[0].del_date).format(
                        "DD MMM, YYYY"
                      )
                      : "N/A"}
                  </p>
                </div>
              </div>

              <div className="col-md-7 col-sm-7">
                <p className="codition">
                  I hereby authorise Katze Technologies to do,necessary repair
                  /replacement /Install and agree to the terms & conditions
                  mentioned below;
                </p>
              </div>
              <div className="col-md-3 col-sm-4 text-center mt-4">
                <b>Received and Satisfied</b>
              </div>

              <div className="col-md-4 col-sm-4 mb-2">
                <p className="mb-0">...............................</p>
                <b>Customer Signature </b>
              </div>

              <div className="col-md-4 col-sm-4">
                <p className="mb-0">.................................</p>
                <b>Received By </b>
              </div>

              <div className="col-md-4 col-sm-4">
                <p className="mb-0">.................................</p>
                <b>Customer Sign </b>
              </div>

              <b className="mb-1 tandc">Terms and Condition:</b>
              <div className="col-md-12 col-sm-12 tc">
                <p>
                  1. I hereby agree to collect the above item back within 15
                  days from today. I also agree that KATZE cannot be held
                  responsible for any loss or damage afterwards, if I failed to
                  do so.
                </p>
                <p>
                  2. I hereby confirm that the above-mentioned item belongs to
                  me or the firm I represent, and I take full responsibility of
                  the same if any dispute or legal actions arises.
                </p>
                <p>
                  3. In case after KATZE inspection, customer does not wish to
                  get the service done, in such case an inspection fee will be
                  charged even without repair.
                </p>
                <p>
                  4. I acknowledge and agree that I have backed up the data
                  prior to given for repair. KATZE will not be liable for loss
                  of data whatsoever.
                </p>
                <p>
                  5. We assume no responsibility for loss or damage due to
                  theft, fire, flood or any other unforeseen beyond its control.
                  (Valuation : 30% depreciation YoY)
                </p>
                <p>
                  6.All disputes shall be subjected to Bangalore Jurisdiction
                  Only.
                </p>
              </div>
              <div className="col-md-6 col-sm-6 border border-secondery mt-2 rounded">
                <table className="table">
                  <tbody>
                    <tr className="tics">
                      <td>
                        <p style={{ color: '#adb5bd' }}>a) PENDING - CUS CONFIR </p>
                      </td>
                      <td>
                        <p style={{ color: '#adb5bd' }}>b) HOLD - TO HQ </p>
                      </td>
                    </tr>
                    <tr className="tics">
                      <td>
                        <p style={{ color: '#adb5bd' }}>c) HOLD - IN HQ</p>
                      </td>
                      <td>
                        <p style={{ color: '#adb5bd' }}>d) HOLD - WAITING RM </p>
                      </td>
                    </tr>
                    <tr className="tics">
                      <td>
                        <p style={{ color: '#adb5bd' }}>e) PENDING - RECEIVED</p>
                      </td>
                      <td>
                        <p style={{ color: '#adb5bd' }}>f) READY - WAITING PO</p>
                      </td>
                    </tr>
                    <tr className="tics">
                      <td>
                        <p style={{ color: '#adb5bd' }}>g) READY - </p>
                      </td>
                      <td>
                        <p style={{ color: '#adb5bd' }}>h) READY - RETURN </p>
                      </td>
                    </tr>
                    <tr className="tics">
                      <td>
                        <p style={{ color: '#adb5bd' }}>i) READY - INFORMED</p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              {usersjob[0].assiger_branch == 1 && (
                <div className="col-md-6 col-sm-6 text-end mt-2">
                  <div className="status-box" style={{ 
                    border: '2px solid #0d6efd',
                    borderRadius: '8px',
                    padding: '8px 15px',
                    backgroundColor: '#f8f9fa',
                    display: 'inline-block'
                  }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: '10px' }}>
                      <p className="mb-0" style={{ color: '#0d6efd', fontSize: '1.1em' }}><b>⏰ Status updates:</b></p>
                      <p className="mb-0" style={{ fontSize: '1.2em' }}><b>📞 895 155 0360</b></p>
                    </div>
                    <p className="mb-0"><b>(Mon-Fri 9:00 - 5:00 PM, Sat till 2:00 PM)</b></p>
                  </div>
                </div>
              )}

              {usersjob[0].assiger_branch == 2 && (
                <div className="col-md-6 col-sm-6 text-end mt-2">
                  <div className="status-box" style={{ 
                    border: '2px solid #0d6efd',
                    borderRadius: '8px',
                    padding: '8px 15px',
                    backgroundColor: '#f8f9fa',
                    display: 'inline-block'
                  }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: '10px' }}>
                      <p className="mb-0" style={{ color: '#0d6efd', fontSize: '1.1em' }}><b>⏰ Status updates:</b></p>
                      <p className="mb-0" style={{ fontSize: '1.2em', whiteSpace: 'nowrap' }}><b>📞 960 682 4959</b></p>
                    </div>
                    <p className="mb-0"><b>(Mon-Fri 9:00 - 5:00 PM, Sat till 2:00 PM)</b></p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="col-md-12 col-sm-12 print-section">
        <div className="row container-fluid">
          <div className="receipt-main col-md-12 col-sm-12">
            <div className="row">
              <div className="orginal-container">
                <p className="orginal-text text-primary">
                  <b className="text-uppercase">Original Copy</b>
                </p>
              </div>
            </div>
            <div className="receipt-header">
              <div className="row">
                <div className="receipt-left col-md-2 col-sm-2">
                  <img
                    src="/logo.png"
                    alt="Default Logo"
                    width="89"
                    height="45"
                  />
                </div>

                <div className="col-md-8 col-sm-8 text-center">
                  {usersjob[0].assiger_branch == 1 && (
                    <div className="receipt-right">
                      <h5>KATZE TECHNOLIGIES - CORPORATE OFFICE</h5>
                      <p>2ND FLOOR, GNR COMPLEX, NEAR SBI BANK,</p>
                      <p>ANEKAL ROAD, CHANDAPURA - 560099</p>
                      <p className="text-ph">
                        <b>MB: 89515 50360</b>
                      </p>
                      <p>Sales@katzeindia.com, www.katzeindia.com</p>
                      <br />
                    </div>
                  )}

                  {usersjob[0].assiger_branch == 2 && (
                    <div className="receipt-right">
                      <h5>KATEZE TECHNOLOGIES - LAPTOPS STORE</h5>
                      <p>4, PARVATHI PLAZA, OPP ANR KALAYNAMANTAP.</p>
                      <p>CHANDAPURA - 560099</p>
                      <p className="text-ph">
                        <b>MB 960 682 4959</b>
                      </p>
                      <p>Sales@katzeindia.com, www.katzeindia.com</p>
                      <br />
                    </div>
                  )}
                </div>
                <div className="col-sm-2"></div>

                <div className="col-md-6 col-sm-6 ">
                  <div className="receipt-right">
                    <p className="pb-1">
                      <b>Customer: </b><b className="h6">{usersjob[0].customer?.company}</b>
                    </p>
                    <h4 className="text-uppercase">
                      <b>{usersjob[0].customer?.name}</b>
                    </h4>
                    <span>
                      <p>
                        <b>
                          <h4 className="text-uppercase">
                            <b>{usersjob[0].customer?.phone}</b>
                          </h4>
                        </b>
                      </p>
                    </span>
                    <p>
                      Email: <b>{usersjob[0].customer?.email}</b>
                    </p>
                    <p>
                      Location: <b>{usersjob[0].customer?.address}</b>
                    </p>
                  </div>
                </div>

                <div className="col-md-6 col-sm-6 text-right-print">
                  <div className="receipt-right">
                    <h5>
                      Job Card No:{" "}
                      <b> {usersjob[0].assiger_branch == 1 ? "K1" : "K2"}</b>
                      {"-"}
                      <b> JC{usersjob[0].id}</b>
                    </h5>
                    <p>
                      Date:
                      <b>
                        {moment(usersjob[0].created_at).format(
                          "DD MMM, YYYY hh:mm A"
                        )}
                      </b>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-4 col-sm-4">
                <table className="table">
                  <tbody>
                    <tr>
                      <td>
                        Received By:{" "}
                        <b className="text-uppercase">
                          {" "}
                          {usersjob[0].assigner?.name}{" "}
                          {usersjob[0].assigner?.last_name}
                        </b>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Brand / Others:{" "}
                        <b className="text-uppercase">{usersjob[0].brand}</b>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div className="col-md-4 col-sm-4">
                <table className="table">
                  <tbody>
                    <tr>
                      <td>
                        Product Name:{" "}
                        <b className="text-uppercase">
                          {usersjob[0].product_name}
                        </b>
                      </td>
                    </tr>

                    <tr>
                      <td>
                        Model:{" "}
                        <b className="text-uppercase">{usersjob[0].model}</b>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div className="col-md-4 col-sm-4">
                <table className="table">
                  <tbody>
                    <tr>
                      <td>
                        Password: <b>{usersjob[0].type}</b>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Priority:{" "}
                        <b className="text-uppercase">{usersjob[0].priority}</b>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div className="col-md-6 col-sm-6">
                <table className="table">
                  <tbody>
                    <tr>
                      <td>
                        Power adapter:{" "}
                        <b>{usersjob[0].power_adapter == 1 ? "YES" : "NO"}</b>
                      </td>
                      <td>
                      Antivirus Required ? {" "}
                        <b>{usersjob[0].carry_case == 1 ? "YES" : "NO"}</b>
                      </td>
                      <td>
                        Laptop Bag:{" "}
                        <b>{usersjob[0].laptop_bag == 1 ? "YES" : "NO"}</b>
                      </td>
                    </tr>
                    <tr>
                      <td colSpan="2">
                        JC Seat Submitted:{" "}
                        <b>
                          {usersjob[0].jc_seat_submitted === "yes"
                            ? "YES"
                            : usersjob[0].jc_seat_submitted === "no"
                            ? "NO"
                            : "N/A"}
                        </b>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div className="col-md-6 col-sm-6 border border-secondery rounded">
                <p className="mb-0">
                  .....................................................................
                </p>
                <p className="mb-0">
                  .....................................................................
                </p>
                <p className="mb-0">
                  .....................................................................
                </p>
              </div>

              <div className="col-md-7 col-sm-7">
                <b>Description / Issues: </b>
                <div className="border border-primary p-1 mb-2 rounded">
                  <p>
                    {usersjob[0].description ? usersjob[0].description : "N/A"}
                  </p>
                </div>
              </div>

              <div className="col-md-5 col-sm-5 mt-1">
                <b>Engg Remarks / Attended By: </b>
                <div className="border border-primary p-1 mb-2 rounded">
                  {" "}
                  <p>
                    {usersjob[0].eng_remark ? usersjob[0].eng_remark : "N/A"}
                  </p>
                </div>
              </div>

              <div className="col-md-4 col-sm-4">
                <b>Damage Remarks: </b>
                <div className="border border-secondery p-1 mb-2 rounded">
                  <p>
                    {usersjob[0].damage_remark
                      ? usersjob[0].damage_remark
                      : "N/A"}
                  </p>
                </div>
              </div>

              <div className="col-md-4 col-sm-4">
                <b>Service Amount: </b>
                <div className="border border-secondery p-1 mb-1 rounded">
                  <p>
                    {usersjob[0].service_amount
                      ? usersjob[0].service_amount
                      : "N/A"}
                  </p>
                </div>
              </div>

              <div className="col-md-4 col-sm-4">
                <b>Tentative Delivery date: </b>
                <div className="border border-secondery p-1 mb-1 rounded">
                  {" "}
                  <p>
                    {usersjob[0].del_date
                      ? moment(usersjob[0].del_date).format(
                        "DD MMM, YYYY"
                      )
                      : "N/A"}
                  </p>
                </div>
              </div>

              <div className="col-md-7 col-sm-7">
                <p className="codition">
                  I hereby authorise Katze Technologies to do,necessary repair
                  /replacement /Install and agree to the terms & conditions
                  mentioned below;
                </p>
              </div>
              <div className="col-md-3 col-sm-4 text-center mt-4">
                <b>Received and Satisfied</b>
              </div>

              <div className="col-md-4 col-sm-4 mb-2">
                <p className="mb-0">...............................</p>
                <b>Customer Signature </b>
              </div>

              <div className="col-md-4 col-sm-4">
                <p className="mb-0">.................................</p>
                <b>Received By </b>
              </div>

              <div className="col-md-4 col-sm-4">
                <p className="mb-0">.................................</p>
                <b>Customer Sign </b>
              </div>

              <b className="mb-1 tandc">Terms and Condition:</b>
              <div className="col-md-12 col-sm-12 tc">
                <p>
                  1. I hereby agree to collect the above item back within 15
                  days from today. I also agree that KATZE cannot be held
                  responsible for any loss or damage afterwards, if I failed to
                  do so.
                </p>
                <p>
                  2. I hereby confirm that the above-mentioned item belongs to
                  me or the firm I represent, and I take full responsibility of
                  the same if any dispute or legal actions arises.
                </p>
                <p>
                  3. In case after KATZE inspection, customer does not wish to
                  get the service done, in such case an inspection fee will be
                  charged even without repair.
                </p>
                <p>
                  4. I acknowledge and agree that I have backed up the data
                  prior to given for repair. KATZE will not be liable for loss
                  of data whatsoever.
                </p>
                <p>
                  5. We assume no responsibility for loss or damage due to
                  theft, fire, flood or any other unforeseen beyond its control.
                  (Valuation : 30% depreciation YoY)
                </p>
                <p>
                  6.All disputes shall be subjected to Bangalore Jurisdiction
                  Only.
                </p>
              </div>
              <div className="row align-items-start mt-2">
                <div className="col-md-6 col-sm-6">
                  <div className="border border-secondery rounded">
                    <table className="table">
                      <tbody>
                        <tr className="tics">
                          <td>
                            <p style={{ color: '#adb5bd' }}>a) PENDING - CUS CONFIR </p>
                          </td>
                          <td>
                            <p style={{ color: '#adb5bd' }}>b) HOLD - TO HQ </p>
                          </td>
                        </tr>
                        <tr className="tics">
                          <td>
                            <p style={{ color: '#adb5bd' }}>c) HOLD - IN HQ</p>
                          </td>
                          <td>
                            <p style={{ color: '#adb5bd' }}>d) HOLD - WAITING RM </p>
                          </td>
                        </tr>
                        <tr className="tics">
                          <td>
                            <p style={{ color: '#adb5bd' }}>e) PENDING - RECEIVED</p>
                          </td>
                          <td>
                            <p style={{ color: '#adb5bd' }}>f) READY - WAITING PO</p>
                          </td>
                        </tr>
                        <tr className="tics">
                          <td>
                            <p style={{ color: '#adb5bd' }}>g) READY - </p>
                          </td>
                          <td>
                            <p style={{ color: '#adb5bd' }}>h) READY - RETURN </p>
                          </td>
                        </tr>
                        <tr className="tics">
                          <td>
                            <p style={{ color: '#adb5bd' }}>i) READY - INFORMED</p>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                {usersjob[0].assiger_branch == 1 && (
                  <div className="col-md-6 col-sm-6 text-end mt-2">
                  <div className="status-box" style={{ 
                    border: '2px solid #0d6efd',
                    borderRadius: '8px',
                    padding: '8px 15px',
                    backgroundColor: '#f8f9fa',
                    display: 'inline-block'
                  }}>
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: '10px' }}>
                        <p className="mb-0" style={{ color: '#0d6efd', fontSize: '1.1em' }}><b>⏰ Status updates:</b></p>
                        <p className="mb-0" style={{ fontSize: '1.2em', whiteSpace: 'nowrap' }}><b>📞 895 155 0360</b></p>
                      </div>
                      <p className="mb-0"><b>(Mon-Fri 9:00 - 5:00 PM, Sat till 2:00 PM)</b></p>
                    </div>
                  </div>
                )}
                {usersjob[0].assiger_branch == 2 && (
                  <div className="col-md-6 col-sm-6 text-end">
                    <div className="status-box" style={{ 
                      border: '2px solid #0d6efd',
                      borderRadius: '8px',
                      padding: '8px 15px',
                      backgroundColor: '#f8f9fa',
                      display: 'inline-block'
                    }}>
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: '10px' }}>
                        <p className="mb-0" style={{ color: '#0d6efd', fontSize: '1.1em' }}><b>⏰ Status updates:</b></p>
                        <p className="mb-0" style={{ fontSize: '1.2em', whiteSpace: 'nowrap' }}><b>📞 960 682 4959</b></p>
                      </div>
                      <p className="mb-0"><b>(Mon-Fri 9:00 - 5:00 PM, Sat till 2:00 PM)</b></p>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
